import { createSelector } from '@ngrx/store';
import { createPartitionStateSelector } from '../../create-partition-state/create-partition-state.selector';
import { SortSelectors } from '../../sort';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const createSearchOverlapsSelector = (filterInstanceId: string) =>
  createSelector(createPartitionStateSelector(filterInstanceId), SortSelectors.createOrderedDataIdsSelector(filterInstanceId), (filterInstanceState, sortedIds: string[]) => {
    if (!filterInstanceState?.searchState.searchOverlaps) {
      return [];
    }

    const filteredDataIdsSet = new Set<string>(filterInstanceState.filterState.filteredDataIds);

    const overlaps = sortedIds
      .map((id) => filterInstanceState.searchState.searchOverlaps[id])
      .filter((searchOverlap) => searchOverlap && filteredDataIdsSet.has(searchOverlap.itemId));

    return overlaps;
  });
